import React, { useState, ChangeEvent } from "react";
import { useNavigate } from "react-router-dom";
import {
  CardMedia,
  Input,
  TextField,
  Button,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";

const AddCustomer = () => {
  const navigate = useNavigate();

  const [image, setImage] = useState<string>("");
  const [fileName, setFileName] = useState<string>("");

  const [gender, setGender] = useState("default");
  const [country, setCountry] = useState("default");
  const [state, setState] = useState("default");
  const [city, setCity] = useState("default");

  const handleChangeGender = (event: SelectChangeEvent) => {
    setGender(event.target.value as string);
  };

  const handleChangeCountry = (event: SelectChangeEvent) => {
    setCountry(event.target.value as string);
  };

  const handleChangeState = (event: SelectChangeEvent) => {
    setState(event.target.value as string);
  };

  const handleChangeCity = (event: SelectChangeEvent) => {
    setCity(event.target.value as string);
  };

  return (
    <>
      <div className="main_title">
        <h1>Add Customer</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          <button onClick={() => navigate("/manage-customers")}>
            Manage Customers
          </button>{" "}
          - Add Customer
        </p>
      </div>

      <div className="cards">
        <div className="form">
          <div className="gap_p">

            {/* ===== Upload Image ===== */}
            <div className="control_group w_100">
              <label htmlFor="icon-button-file">Image<span className="req">*</span></label>
              {image ? (
                <div className="upload_image">
                  <div className="upload_image_holder">
                    <figure>
                      <CardMedia component="img" image={image} alt="photo" />
                    </figure>
                    <CloseIcon
                      onClick={() => {
                        setImage("");
                        setFileName("");
                      }}
                    />
                  </div>
                </div>
              ) : (
                <label className="upload_image" htmlFor="icon-button-file">
                  <Input
                    sx={{ display: "none" }}
                    id="icon-button-file"
                    type="file"
                    inputProps={{
                      accept: "image/png,image/jpeg",
                    }}
                    onChange={(event: ChangeEvent<HTMLInputElement>) => {
                      const files = (event.target as HTMLInputElement).files;
                      if (files && files[0].type.includes("image")) {
                        setFileName(files[0].name);
                        setImage(URL.createObjectURL(files[0]));
                      }
                    }}
                  />
                  <span className="upload_image_holder">
                    <figure className="add_img">
                      <img src="/static/images/user_placeholder.png" alt="icon" />
                      <span className="upload_img_icon">
                        <img src="/static/images/edit2_icon.svg" alt="icon" />
                      </span>
                    </figure>
                  </span>
                </label>
              )}
            </div>

            {/* ===== Name and Email ===== */}
            <div className="control_group w_50">
              <label htmlFor="name">Name<span className="req">*</span></label>
              <TextField
                id="name"
                placeholder="Enter Name"
                fullWidth
                hiddenLabel
              />
            </div>

            <div className="control_group w_50">
              <label htmlFor="email">Email<span className="req">*</span></label>
              <TextField
                id="email"
                placeholder="Enter Email"
                fullWidth
                hiddenLabel
              />
            </div>

            {/* ===== Phone, Gender, Country ===== */}
            <div className="control_group w_33">
              <label htmlFor="phone">Phone Number<span className="req">*</span></label>
              <PhoneInput
                inputProps={{ id: "phone" }}
                country={"in"}
                placeholder="Enter Phone Number"
                enableSearch={false}
                inputStyle={{ width: "100%" }}
              />
            </div>

            <div className="control_group w_33">
              <label htmlFor="gender">Gender<span className="req">*</span></label>
              <Select
                id="gender"
                fullWidth
                value={gender}
                onChange={handleChangeGender}
              >
                <MenuItem disabled value="default">Select Gender</MenuItem>
                <MenuItem value="male">Male</MenuItem>
                <MenuItem value="female">Female</MenuItem>
                <MenuItem value="other">Other</MenuItem>
              </Select>
            </div>
            <div className="control_group w_33">
              <label htmlFor="pin">Generate temporary password & force reset</label>
              <TextField
                id="pin"
                placeholder="Enter passowrd"
                fullWidth
                hiddenLabel
              />
            </div>
            <div className="control_group w_33">
              <label htmlFor="country">Country<span className="req">*</span></label>
              <Select
                id="country"
                fullWidth
                value={country}
                onChange={handleChangeCountry}
              >
                <MenuItem disabled value="default">Select Country</MenuItem>
                <MenuItem value="india">India</MenuItem>
                <MenuItem value="usa">USA</MenuItem>
                <MenuItem value="uk">UK</MenuItem>
              </Select>
            </div>

            {/* ===== State, City, Pin ===== */}
            <div className="control_group w_33">
              <label htmlFor="state">State<span className="req">*</span></label>
              <Select
                id="state"
                fullWidth
                value={state}
                onChange={handleChangeState}
              >
                <MenuItem disabled value="default">Select State</MenuItem>
                <MenuItem value="maharashtra">Maharashtra</MenuItem>
                <MenuItem value="gujarat">Gujarat</MenuItem>
                <MenuItem value="delhi">Delhi</MenuItem>
              </Select>
            </div>

            <div className="control_group w_33">
              <label htmlFor="city">City<span className="req">*</span></label>
              <Select
                id="city"
                fullWidth
                value={city}
                onChange={handleChangeCity}
              >
                <MenuItem disabled value="default">Select City</MenuItem>
                <MenuItem value="mumbai">Mumbai</MenuItem>
                <MenuItem value="pune">Pune</MenuItem>
                <MenuItem value="ahmedabad">Ahmedabad</MenuItem>
              </Select>
            </div>

            <div className="control_group w_33">
              <label htmlFor="pin">Pin Code<span className="req">*</span></label>
              <TextField
                id="pin"
                placeholder="Enter Pin"
                fullWidth
                hiddenLabel
              />
            </div>

            {/* ===== Address Lines ===== */}
            <div className="control_group w_50">
              <label htmlFor="address1">Address Line 1<span className="req">*</span></label>
              <TextField
                id="address1"
                placeholder="Enter Address Line 1"
                fullWidth
                hiddenLabel
              />
            </div>

            <div className="control_group w_50">
              <label htmlFor="address2">Address Line 2<span className="req">*</span></label>
              <TextField
                id="address2"
                placeholder="Enter Address Line 2"
                fullWidth
                hiddenLabel
              />
            </div>


          </div>

          {/* ===== Save Button ===== */}
          <div className="form_btn">
            <Button className="btn btn_primary">Save</Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddCustomer;
